import React from "react"
import Icon from "Components/Icon";

export interface IProps {
    title: string
    visible: boolean
    onCancel: () => void
    dontClose?: boolean
    children?: any
}

class BottomSheet extends React.Component<IProps> {
    state = { isShow: false, closing: false }
    componentDidMount() {
        document.addEventListener("keydown", this.escFunction, false);
    }
    componentDidUpdate(prevProps: IProps) {
        if (prevProps.visible !== this.props.visible) {
            if (this.props.visible) {
                setTimeout(() => {
                    this.setState({ isShow: this.props.visible, closing: true });
                }, 100);
            } else
                this.onClose();
        }
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.escFunction, false);
    }
    onClose = () => {
        if (!(this.props.dontClose == true)) {
            if (this.props.onCancel) {
                this.setState({ isShow: false }, () => {
                    setTimeout(() => {
                        if (this.props.onCancel)
                            this.props.onCancel()
                        this.setState({ closing: false });
                    }, 100);
                })
            }
        }
    }
    escFunction = (event: any) => {
        if (event.key === "Escape") {
            this.onClose()
        }
    }

    render() {
        if (!this.props.visible && !this.state.closing)
            return null
        return (
            <React.Fragment>
                <div className={`fixed inset-0 group/bottomsheet z-10 ${(this.state.isShow ? "show-bottomsheet" : "")}`}>
                    <div className="backdrop group-[.show-bottomsheet]/bottomsheet:opacity-100 group-[.show-bottomsheet]/bottomsheet:pointer-events-auto" onClick={this.onClose} />
                    <div
                        className="fixed bottom-0 inset-x-0 flex flex-col z-40 bg-white rounded-t-2xl shadow-sm pt-2 transition-transform translate-y-full group-[.show-bottomsheet]/bottomsheet:translate-y-0 max-h-[95%]">
                        <div className="grow flex flex-col overflow-hidden">
                            <div className="flex justify-between items-center h-16 px-6 shrink-0">
                                <div className="flex justify-between items-center gap-2">
                                    <div className="text-lg font-bold pl-2">
                                        {this.props.title}
                                    </div>
                                </div>
                                <div className="flex justify-between items-center">
                                    {!(this.props.dontClose == true) &&
                                        <div className="relative" onClick={() => this.props.onCancel()}>
                                            <Icon name="close" className="w-6 h-6 text-gray-600" />
                                        </div>}
                                </div>
                            </div>
                            {this.props.children}
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default BottomSheet;